<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Quản lý tài khoản</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Danh sách tài khoản</div>
        <p-button type="success" @click="newUser">Tạo tài khoản mới</p-button>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="50"
              class-name="td-actions"
              label="Hành động">
              <template slot-scope="props">
                <p-button title="Chỉnh sửa" type="info" size="sm" icon @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button title="Xóa tài khoản" type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Hiển thị {{from + 1}} đến {{to}} trong {{total}} tài khoản </p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
    <CreateUser>    

    </CreateUser>
    <EditUser 
      v-bind:username="passThroughUsername"> 

    </EditUser>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import axios from "axios";
  import VueAxios from "vue-axios";

  import CreateUser from './CreateUser.vue'
  import EditUser from './EditUser.vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination,
      CreateUser,
      EditUser
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['name', 'info'],
        tableColumns: [
          {
            prop: 'username',
            label: 'Tên tài khoản',
            minWidth: 120
          },
          {
            prop: 'info',
            label: 'Thông tin',
            minWidth: 150
          },
          {
            prop: 'node',
            label: 'Node điều khiển',
            minWidth: 100
          },
        ],
        tableData: [],
        passThroughUsername: '',
      }
    },
    created() {
      let tokenkey = localStorage.getItem('token');
      let data = {
        tokenkey: tokenkey
      }
      const that = this;
      axios({url: '/Account/ViewAll', 
             data: data, 
             method: 'POST' })
      .then(function(res){
        for (var property in res.data) {
          if (res.data.hasOwnProperty(property)) {
            if (res.data[property].permission == 0) {
              delete res.data[property];
            } else {
              that.$data.tableData.push(res.data[property]);
            }
          }
        }
        // console.log(that.$data.tableData) 
        return(res)
      })
      .catch(function(err){
        alert("Tải dữ liệu thất bại")
        return(err)
      })
    }
    ,
    methods: {
      handleEdit (index, row) {
        this.passThroughUsername = row.username;
        //document.getElementById('node_control').style.transform='scale(0.7)';
        document.getElementById('edit-user').style.display='block';
      },
      handleDelete (index, row) {
        const that = this;
        let tokenkey = localStorage.getItem('token');
          let data = {
            tokenkey: tokenkey,
            username: row.username,
          }
          axios({url: '/Account/RemoveUser', 
                data: data, 
                method: 'POST' })
          .then(function(res){
            alert('Xóa tài khoản thành công');
            location.reload();
            return(res)
          })
          .catch(function(err){
            alert("Xóa tài khoản thất bại")
            location.reload();
            return(err)
          })
      },
      newUser() {
        document.getElementById('create-user').style.display='block';
      }
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }
  body.modal-open {
    height: 100vh;
    overflow-y: hidden;
  }
</style>
